/*  MUI  */
import { Box, Paper } from '@mui/material';

/*  Shared  */
import {
    ManagedTableV2UI,
    useManagedTableV2Context
} from 'application/Shared/Components/Table';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const csvExportFields = (t) => [
    { id: 'application', key: 'application.name', label: t('Common.app_name') },
    {
        id: 'category',
        key: 'application.category',
        label: t('Common.applicationCategory')
    },
    {
        id: 'subCategory',
        key: 'application.subCategory',
        label: t('Common.sub_category')
    },
    { id: 'dateAdded', key: 'dateAdded', label: t('Common.dateDiscovered') },
    { id: 'users', key: 'userCount', label: t('Common.activeUserCount') },
    { id: 'riskFilter', key: 'risk', label: t('Common.risk') },
    {
        id: 'workLoginPercent',
        key: 'workLoginPercent',
        label: t('Common.workUsagePercent')
    },
    { id: 'type', key: 'type', label: t('Common.type') },
    {
        id: 'businessOwnerType',
        key: 'ownerName',
        label: t('Common.business_owner')
    },
    {
        id: 'usage',
        key: 'usage',
        label: t('Common.usageLast90'),
        transform: 'hms'
    },
    { id: 'classified', key: 'classified', label: t('Common.classified') },
    { id: 'status', key: 'status', label: t('Common.lifecycleStage') },
    {
        id: 'tags',
        key: 'tags',
        label: t('Common.tags'),
        rowKeyAndDataPath: 'tagLinks:globalTag.name',
        transform: 'listExtract'
    },
    {
        id: 'managementStage',
        key: 'managementStage',
        label: t('Common.applicationState')
    },
    {
        key: 'application.description',
        label: t('Common.description')
    },
    { id: 'source', key: 'sourceNames', label: t('Common.sources') },
    { id: 'lastUsed', key: 'lastUsed', label: t('Common.last_used') },
    {
        id: 'publisher',
        key: 'application.publisherName',
        label: t('Common.publisher')
    }
];

export const ClientAppsTable = () => {
    const { t } = useTranslation();
    const { bulkActions } = useManagedTableV2Context();

    const currentCsvExportFields = csvExportFields(t);

    return (
        <Box data-testid="clientAppsTable">
            <Paper elevation={0} variant="outlined" sx={{ mt: '24px', p: 0 }}>
                <ManagedTableV2UI
                    bulkActions={bulkActions}
                    csvExport
                    csvExportFields={currentCsvExportFields}
                    csvExportFileName="applications"
                    enableDnD
                    enableShowHideColumns
                    renderFooter
                    titleDef={{ titleKey: 'Common.applicationWithCount' }}
                />
            </Paper>
        </Box>
    );
};
